/* eslint-disable indent */
/* eslint-disable no-trailing-spaces */
import Siema from 'siema';

export default class HandleYearRoundSlider {
    constructor(sliderClass) {
      this.element = sliderClass;
      this.next = document.querySelector('.js--yearround-slider--next');
      this.previous = document.querySelector('.js--yearround-slider--previous');
      this.sliderItems = document.querySelectorAll('.yearround-item');
      if(this.sliderItems.length > 0){
        this.mySiema = new Siema({
          selector: this.element,
          duration: 0,
          draggable: false,
          perPage: 1,
          loop: true,
        });
        this._setDOMReferences();
      }
    }

    _setDOMReferences() {
        if(this.sliderItems.length > 0) {
            this.next.addEventListener('click', () => this.mySiema.next());
            this.previous.addEventListener('click', () => this.mySiema.prev());
        }
    }
}

